module.exports = __webpack_public_path__ + "assets/img_gluten_free.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_gluten_free.png
 ** module id = 123
 ** module chunks = 1
 **/